import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import MessagesTable from "./MessagesTable";
import MessagesDeleteModal from "./MessagesDeleteModal";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const MessagesPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.ViewToolManagementMessages, permissionSet ?? []) ? (
        <div className={`layout__contentPage__${theme}`}>
          <MessagesTable />
          <MessagesDeleteModal />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default MessagesPage;
